export default {
  title: "Join Our Waitlist",
  description:
    "Be the first to experience our advanced features and get early access to upcoming releases.",
  emailPlaceholder: "Enter your email",
  submitButton: {
    default: "Join Waitlist",
    submitting: "Joining...",
  },
  messages: {
    success: "Thank you for joining our waitlist! We will contact you soon.",
    alreadyExists:
      "You're already in our waitlist. We'll keep you informed of all the latest news.",
    error: "Submission failed: Please try again later.",
    invalidEmail: "Please enter a valid email address.",
    unknownError: "An unknown error occurred. Please try again later.",
  },
};
